import React from 'react';
import MainWindow from '../MainWindowComponent/MainWindow';
import './App.css';

const App = () => {
	var getSearchParameters = () => {
		var match,
			pl = /\+/g,  // Regex for replacing addition symbol with a space
			search = /([^&=]+)=?([^&]*)/g,
			decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
			query = window.location.search.substring(1);

		var urlParams = {};
		while (match = search.exec(query))
			urlParams[decode(match[1])] = decode(match[2]);
		return urlParams;
	};
	var searchParameters = getSearchParameters();
	searchParameters.minHeight = 570; 
	return (
		<div className="App">
			<MainWindow searchParameters={searchParameters}/>
		</div>

		// <div className="App-local" >
		// 		<MainWindow searchParameters={searchParameters} />
		// </div>
	);
}

export default App;
